import React from 'react';
import { useStyles } from './styles/SubBar.styles';

interface SubBarProps {
    children?: React.ReactNode;
    className?: string;
}

export const SubBar = ({ children, className }: SubBarProps) => {
    const classes = useStyles();

    return <div className={className ? className : classes.subMenuBar}>{children ? children : null}</div>;
};
